.biel-search-button-content {
  cursor: pointer;
  width: var(--biel-search-button-width);
  max-width: var(--biel-search-button-max-width);
}

.biel-search-button-content--rounded {
  display: flex;
  align-items: center;
  background-color: var(--biel-search-button-bg-color);
  border-radius: var(--biel-search-button-border-radius);
  color: var(--biel-search-button-text-color);
  padding: var(--biel-search-button-padding);
  font-family: var(--biel-font-family);
  font-weight: var(--biel-search-button-text-font-weight);
  font-size: var(--biel-search-button-text-font-size);
  border: 1px solid var(--biel-search-button-border-color);
}

.biel-search-button-content--rounded slot {
  display: var(--biel-search-button-text-display);
}

.biel-search-button-content-icon {
  margin-right: var(--biel-search-button-icon-margin-right);
  height: var(--biel-search-button-icon-size);
  width: var(--biel-search-button-icon-size);
}

.biel-search-button-content-ctrl-k {
  display: var(--biel-search-button-ctrl-k-display);
  margin-left: auto;
  padding-left: 12px;
  font-size: 12px;
}
